module.exports = __webpack_public_path__ + "img/HomeTrack_Dashboard_Logo_RGB_White.148ef0a1.svg";